import React from 'react';
import PictureWithLightBox from "./PictureWithLightBox";
import FileTypeIcon from "./FileTypeIcon";
import get from "lodash/get";
import {isImage} from "../helpers/javascriptHelpers";
import { useRecordContext } from 'react-admin';
const LightBoxField = ({label, source, record: recordProp }) => {
  const recordFromContext = useRecordContext();
  const record = recordProp || recordFromContext;
    if (!record) {
        return null;
    }
    let value = get(record, source);
    if (Array.isArray(value)) {
        const first = value[0];
        value = first && first.filePath ? first.filePath : first;
    }

    if (!value || Array.isArray(value)) {
        return null;
    }

    return (
        isImage(value)
            ? <PictureWithLightBox title={label} picture={value}/>
            : <FileTypeIcon filePath={value} title={label}/>
    );
};

export default LightBoxField;
